"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NodeTypeSchema = exports.NodeConfigSchema = exports.artifactType = void 0;
const finley_types_1 = require("@finley-technologies/finley-types");
const v4_1 = require("zod/v4");
exports.artifactType = 'assignedLoanTape';
// NodeConfig schema and type
exports.NodeConfigSchema = v4_1.z
    .object({})
    .describe('No extra config for assignedLoanTape');
// Zod schema for NodeType
exports.NodeTypeSchema = finley_types_1.DbTable.ArtifactWithSlugsSchema.omit({
    configuration: true,
    type: true,
}).extend({
    type: v4_1.z.literal(exports.artifactType),
    externalFilename: v4_1.z.null(),
    loanProductSlug: v4_1.z.string(),
    creditFacilitySlug: v4_1.z.string(),
    configuration: exports.NodeConfigSchema,
});
//# sourceMappingURL=node.js.map